import { useEffect, useState } from "react";
import {
  Send,
  Paperclip,
  AlertCircle,
  ClipboardList
} from "lucide-react";
import useDocumentTitle from '../../hooks/useDocumentTitle'
import { fetchService, fetchServiceissues, CreateTickets, selectServiceStatus, selectservicesData } from "./ticketSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-hot-toast';
import { Link } from "react-router-dom";

export default function CreateTicket() {
  useDocumentTitle('Create Ticket');
  const [services, setServices] = useState([]);
  const [issues, setIssues] = useState([]);
  const dispatch = useDispatch();
  const servicesData = useSelector(selectservicesData);
  const ServiceStatus = useSelector(selectServiceStatus);

  const [form, setForm] = useState({
    service_id: "",
    issue_type_id: "",
    priority_id: "",
    booking_reference: "",
    description: "",
    attachments: []
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    dispatch(fetchService({}));
  }, [dispatch]);

  useEffect(() => {
    setServices(servicesData)
  }, [ServiceStatus, servicesData]);

  useEffect(() => {
    if (form.service_id) {
      handleissues(form.service_id)
    } else {
      setIssues([]);
    }
  }, [form.service_id]);

  const handleissues = async (service_id) => {
    const response = await dispatch(
      fetchServiceissues({ service_id: service_id })
    ).unwrap();
    const { data } = response;
    setIssues(data);
  }

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = e => {
    setForm({
      ...form,
      attachments: Array.from(e.target.files)
    });
    // setForm({ ...form, attachments: e.target.files });
  };

  const submitTicket = async e => {
    e.preventDefault();
    setLoading(true);
    setError("");

    const formData = new FormData();
    formData.append("service_id", form.service_id);
    formData.append("issue_type_id", form.issue_type_id);
    formData.append("priority_id", form.priority_id);
    formData.append("booking_reference", form.booking_reference || "");
    formData.append("description", form.description);

    form.attachments.forEach(file => {
      formData.append("attachments[]", file);
    });

    try {
      const response = await dispatch(
        CreateTickets(formData)
      ).unwrap();
      const { data } = response;
      //await axios.post("/api/tickets", data); 
      // alert("Ticket created successfully");
      window.location.reload();
      toast.success("Ticket created successfully", { autoClose: 2000 });
    } catch (err) {
      console.log(err);
      toast.error(err.message, { autoClose: 2000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="bg-gray-100 text-gray-800 relative min-h-screen">

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 space-y-6">

          <div className="max-w-3xl mx-auto bg-white shadow-xl rounded-2xl p-8">

            <div className="flex items-center gap-3 mb-6">
              <ClipboardList className="w-7 h-7 text-indigo-600" />
              <h2 className="text-2xl font-bold">Raise Support Ticket</h2>
              <div className="relative inline-block text-left">
                <Link
                  className={`px-5 py-2 rounded font-medium shadow transition flex items-center gap-2 bg-blue-600 text-white `}
                  to='/ticket'>
                  Back
                </Link>
              </div>
            </div>

            {error && (
              <div className="flex items-center gap-2 bg-red-100 text-red-700 p-3 rounded mb-4">
                <AlertCircle className="w-4 h-4" />
                {error}
              </div>
            )}

            <form onSubmit={submitTicket} className="space-y-5">
              {/* Service */}
              <div>
                <label className="block font-medium mb-1">Service</label>
                <select
                  name="service_id"
                  value={form.service_id}
                  onChange={handleChange}
                  className="w-full border rounded-lg px-4 py-2"
                  required
                >
                  <option value="">Select Service</option>
                  {services.map(service => (
                    <option key={service.id} value={service.id}>
                      {service.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Issue */}
              <div>
                <label className="block font-medium mb-1">Issue Type</label>
                <select
                  name="issue_type_id"
                  value={form.issue_type_id}
                  onChange={handleChange}
                  className="w-full border rounded-lg px-4 py-2"
                  required
                  disabled={!issues.length}
                >
                  <option value="">Select Issue</option>
                  {issues.map(issue => (
                    <option key={issue.id} value={issue.id}>
                      {issue.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Priority */}
              <div>
                <label className="block font-medium mb-1">Priority</label>
                <select
                  name="priority_id"
                  value={form.priority_id}
                  onChange={handleChange}
                  className="w-full border rounded-lg px-4 py-2"
                  required
                >
                  <option value="">Select Priority</option>
                  <option value="1">High</option>
                  <option value="2">Medium</option>
                  <option value="3">Low</option>
                </select>
              </div>

              {/* Booking Ref */}
              <div>
                <label className="block font-medium mb-1">
                  Booking Reference (Optional)
                </label>
                <input
                  type="text"
                  name="booking_reference"
                  value={form.booking_reference}
                  onChange={handleChange}
                  className="w-full border rounded-lg px-4 py-2"
                  placeholder="PNR / Booking ID"
                />
              </div>

              {/* Description */}
              <div>
                <label className="block font-medium mb-1">Description</label>
                <textarea
                  name="description"
                  value={form.description}
                  onChange={handleChange}
                  rows="5"
                  className="w-full border rounded-lg px-4 py-2"
                  placeholder="Explain your issue in detail..."
                  required
                />
              </div>

              {/* Attachments */}
              <div>
                <label className="block font-medium mb-2 flex items-center gap-2">
                  <Paperclip className="w-4 h-4" />
                  Attach Files
                </label>
                <input
                  type="file"
                  multiple
                  accept=".jpg,.jpeg,.png,.pdf,.mp4,.mov,.avi,.webm"
                  onChange={handleFileChange}
                  className="block w-full"
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={loading}
                className="flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white px-6 py-3 rounded-xl font-semibold transition"
              >
                <Send className="w-4 h-4" />
                {loading ? "Submitting..." : "Submit Ticket"}
              </button>
            </form>
          </div>
        </main>

      </div>
      {/* <SearchForm /> */}

    </>
  );
}
